<template>
  <div class="table-responsive mt-3 mb-0">
    <div class="container-div">
      <!-- Calendar -->
      <div
        class="d-flex"
        @dblclick="showAddEvent('12', '00', 'AM', $event)"
        @click.right="showAddMenu('12', '00', 'AM', $event)"
      >
        <div class="time-div">12am</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('1', '00', 'AM', $event)"
        @click.right="showAddMenu('1', '00', 'AM', $event)"
      >
        <div class="time-div">1am</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('2', '00', 'AM', $event)"
        @click.right="showAddMenu('2', '00', 'AM', $event)"
      >
        <div class="time-div">2am</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('3', '00', 'AM', $event)"
        @click.right="showAddMenu('3', '00', 'AM', $event)"
      >
        <div class="time-div">3am</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('4', '00', 'AM', $event)"
        @click.right="showAddMenu('4', '00', 'AM', $event)"
      >
        <div class="time-div">4am</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('5', '00', 'AM', $event)"
        @click.right="showAddMenu('5', '00', 'AM', $event)"
      >
        <div class="time-div">5am</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('6', '00', 'AM', $event)"
        @click.right="showAddMenu('6', '00', 'AM', $event)"
      >
        <div class="time-div">6am</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('7', '00', 'AM', $event)"
        @click.right="showAddMenu('7', '00', 'AM', $event)"
      >
        <div class="time-div">7am</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('8', '00', 'AM', $event)"
        @click.right="showAddMenu('8', '00', 'AM', $event)"
      >
        <div class="time-div">8am</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('9', '00', 'AM', $event)"
        @click.right="showAddMenu('9', '00', 'AM', $event)"
      >
        <div class="time-div">9am</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('10', '00', 'AM', $event)"
        @click.right="showAddMenu('10', '00', 'AM', $event)"
      >
        <div class="time-div">10am</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('11', '00', 'AM', $event)"
        @click.right="showAddMenu('11', '00', 'AM', $event)"
      >
        <div class="time-div">11am</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('12', '00', 'PM', $event)"
        @click.right="showAddMenu('12', '00', 'PM', $event)"
      >
        <div class="time-div">12pm</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('1', '00', 'PM', $event)"
        @click.right="showAddMenu('1', '00', 'PM', $event)"
      >
        <div class="time-div">1pm</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('2', '00', 'PM', $event)"
        @click.right="showAddMenu('2', '00', 'PM', $event)"
      >
        <div class="time-div">2pm</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('3', '00', 'PM', $event)"
        @click.right="showAddMenu('3', '00', 'PM', $event)"
      >
        <div class="time-div">3pm</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('4', '00', 'PM', $event)"
        @click.right="showAddMenu('4', '00', 'PM', $event)"
      >
        <div class="time-div">4pm</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('5', '00', 'PM', $event)"
        @click.right="showAddMenu('5', '00', 'PM', $event)"
      >
        <div class="time-div">5pm</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('6', '00', 'PM', $event)"
        @click.right="showAddMenu('6', '00', 'PM', $event)"
      >
        <div class="time-div">6pm</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('7', '00', 'PM', $event)"
        @click.right="showAddMenu('7', '00', 'PM', $event)"
      >
        <div class="time-div">7pm</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('8', '00', 'PM', $event)"
        @click.right="showAddMenu('8', '00', 'PM', $event)"
      >
        <div class="time-div">8pm</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('9', '00', 'PM', $event)"
        @click.right="showAddMenu('9', '00', 'PM', $event)"
      >
        <div class="time-div">9pm</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('10', '00', 'PM', $event)"
        @click.right="showAddMenu('10', '00', 'PM', $event)"
      >
        <div class="time-div">10pm</div>
        <div class="content-div"></div>
      </div>
      <div
        class="d-flex"
        @dblclick="showAddEvent('11', '00', 'PM', $event)"
        @click.right="showAddMenu('11', '00', 'PM', $event)"
      >
        <div class="time-div">11pm</div>
        <div class="content-div"></div>
      </div>
      <!-- /Calendar -->

      <!-- Events -->
      <div
        v-for="(rec, i) in events"
        :key="i"
        :id="`event${rec.Id}`"
        :class="
          !rec.IsPublicHoliday
            ? rec.Id == selectedEventId
              ? 'event-div selected'
              : 'event-div'
            : 'event-div border-gray'
        "
        :style="`background-color:${rec.Color}`"
        @click="selectEvent(rec, $event)"
        @dblclick="showEditEvent(rec, $event)"
        @click.right="showEditMenu(rec, $event)"
      >
        <template v-if="!rec.IsPublicHoliday">
          <span class="time-span">{{ rec.StartTime }}</span>
          <br />
        </template>
        <span class="event-span">{{ rec.EventName }}</span>
      </div>
      <!-- /Events -->

      <!-- Add-Edit Event Modal -->
      <div class="modal custom-modal fade" id="addEvent" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header pt-4">
              <h5 class="modal-title">{{ id ? "Edit" : "Add" }} Event</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body pt-3">
              <form @submit.prevent="save">
                <div class="form-group">
                  <label class="mb-0">
                    Event Name<span class="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    v-model="eventName"
                    class="form-control"
                    maxlength="100"
                    required
                  />
                </div>
                <div class="form-group">
                  <label class="mb-0">Location</label>
                  <input
                    type="text"
                    v-model="location"
                    class="form-control"
                    maxlength="100"
                  />
                </div>
                <div class="form-group">
                  <label class="mb-0">
                    Date<span class="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="date"
                    required
                  />
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="form-group col-md-6 mb-0">
                      <label class="mb-0">
                        Start Time<span class="text-danger">*</span>
                      </label>
                      <div class="d-flex align-items-center">
                        <select
                          v-model="startHour"
                          class="form-control form-control-sm fit-content"
                          required
                        >
                          <option value>0</option>
                          <option
                            v-for="item in timingHours"
                            :value="item"
                            :key="item"
                          >
                            {{ item }}
                          </option>
                        </select>
                        <span class="mx-1">:</span>
                        <select
                          v-model="startMinute"
                          class="form-control form-control-sm fit-content"
                        >
                          <option
                            v-for="item in timingMinutes"
                            :value="item"
                            :key="item"
                          >
                            {{ item }}
                          </option>
                        </select>
                        <select
                          v-model="startTimePart"
                          class="form-control form-control-sm ml-2 fit-content"
                        >
                          <option value="AM">AM</option>
                          <option value="PM">PM</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group col-md-6 mb-0">
                      <label class="mb-0">
                        End Time<span class="text-danger">*</span>
                      </label>
                      <div class="d-flex align-items-center">
                        <select
                          v-model="endHour"
                          class="form-control form-control-sm fit-content"
                          required
                        >
                          <option value>0</option>
                          <option
                            v-for="item in timingHours"
                            :value="item"
                            :key="item"
                          >
                            {{ item }}
                          </option>
                        </select>
                        <span class="mx-1">:</span>
                        <select
                          v-model="endMinute"
                          class="form-control form-control-sm fit-content"
                        >
                          <option
                            v-for="item in timingMinutes"
                            :value="item"
                            :key="item"
                          >
                            {{ item }}
                          </option>
                        </select>
                        <select
                          v-model="endTimePart"
                          class="form-control form-control-sm ml-2 fit-content"
                        >
                          <option value="AM">AM</option>
                          <option value="PM">PM</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="mb-0">Notes</label>
                  <textarea
                    class="form-control"
                    maxlength="200"
                    v-model="notes"
                  ></textarea>
                </div>
                <!-- Button -->
                <div class="submit-section mt-4">
                  <button type="submit" class="btn btn-primary submit-btn">
                    {{ id ? "Update" : "Add" }}
                  </button>
                </div>
                <!-- /Button -->
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- /Add-Edit Event Modal -->

      <!-- Add Menu Right Click -->
      <div
        tabindex="-1"
        class="card m-0 menu"
        id="addMenu"
        ref="addMenu"
        :style="`top:${top};left:${left};display:none`"
        @blur="closeAddMenu"
      >
        <div class="card-body p-0">
          <div
            @click="showAddEvent(null, null, null, $event)"
            class="menu-item"
          >
            <i class="fa fa-plus-circle mr-1"></i>Add Event
          </div>
        </div>
      </div>
      <!-- /Add Menu Right Click -->

      <!-- Edit Menu Right Click -->
      <div
        tabindex="-1"
        class="card m-0 menu"
        :id="'editMenu'"
        :ref="'editMenu'"
        :style="`top:${top};left:${left};display:none`"
        @blur="closeEditMenu"
      >
        <div class="card-body p-0">
          <div @click="showEditEvent(null, $event)" class="menu-item">
            <i class="fa fa-pencil mr-1"></i>Edit
          </div>
          <div @click="remove" class="menu-item">
            <i class="fa fa-trash-o mr-1"></i>Delete
          </div>
        </div>
      </div>
      <!-- /Edit Menu Right Click -->
    </div>
  </div>
</template>

<script>
import API from "../../../http-common.js";
import $ from "jquery";
export default {
  props: ["selectedDate", "instructorId", "selectedCountries"],
  data() {
    return {
      events: [],
      //for modal
      id: "",
      eventName: "",
      location: "",
      date: "",
      startHour: "",
      startMinute: "00",
      startTimePart: "AM",
      endHour: "",
      endMinute: "00",
      endTimePart: "AM",
      notes: "",
      country: "",
      //for right click menu
      top: "0px",
      left: "0px",
      scrollTop: 0,
      selectedEventId: "",
    };
  },
  watch: {
    "$store.state.expandSidebar": function (val) {
      window.setTimeout(() => {
        this.loadCalendar(this.events);
      }, 300);
    },
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    timingHours() {
      let hours = [];
      for (let i = 1; i <= 12; i++) {
        hours.push(i);
      }
      return hours;
    },
    timingMinutes() {
      let minutes = [];
      for (let i = 0; i <= 59; i++) {
        minutes.push(i.toString().padStart(2, "0"));
      }
      return minutes;
    },
  },
  methods: {
    //modal add and edit
    showAddEvent(startHour, startMinute, startTimePart, event) {
      event.preventDefault();
      this.id = "";
      this.eventName = "";
      this.location = "";
      this.date = this.selectedDate;
      if (startHour && startMinute && startTimePart) {
        this.startHour = startHour;
        this.startMinute = startMinute;
        this.startTimePart = startTimePart;
      }
      this.endHour = "";
      this.endMinute = "00";
      this.endTimePart = "AM";
      this.notes = "";
      $("#addMenu").hide();
      // $("#addEvent").modal("show");
      let obj = {
        date: this.date,
        startHour: this.startHour,
        startMinute: this.startMinute,
        startTimePart: this.startTimePart,
      };
      this.$emit("showAddEventFromComponent", obj);
    },
    showEditEvent(payload, event) {
      event.preventDefault();
      event.cancelBubble = true;
      if (event.stopPropagation) event.stopPropagation();
      if (payload) {
        this.id = payload.Id;
        this.eventName = payload.EventName;
        this.location = payload.Location;
        this.date = this.selectedDate;
        this.startHour = payload.StartHour;
        this.startMinute = payload.StartMinute.toString().padStart(2, "0");
        this.startTimePart = payload.StartTimePart;
        this.endHour = payload.EndHour;
        this.endMinute = payload.EndMinute.toString().padStart(2, "0");
        this.endTimePart = payload.EndTimePart;
        this.notes = payload.Notes;
        if (payload.IsPublicHoliday) {
          let obj = {
            eventName: payload.EventName,
            date: payload.DateStartDisplay,
            country: payload.Country,
          };
          this.$emit("showPublicHoliday", obj);
          return;
        }
      }
      $("#editMenu").hide();
      // $("#addEvent").modal("show");
      let obj = {
        id: this.id,
        eventName: this.eventName,
        location: this.location,
        date: this.date,
        startHour: this.startHour,
        startMinute: this.startMinute,
        startTimePart: this.startTimePart,
        endHour: this.endHour,
        endMinute: this.endMinute,
        endTimePart: this.endTimePart,
        notes: this.notes,
      };
      this.$emit("showEditEventFromComponent", obj);
    },
    selectEvent(payload, event) {
      if (!payload.IsPublicHoliday) {
        this.selectedEventId = payload.Id;
        this.$emit("selectEvent", payload);
      }
    },
    //menu add and edit
    updateCalendar() {
      window.setTimeout(() => {
        if (this.events && this.events.length) {
          this.loadCalendar(this.events);
        }
      }, 300);
    },
    updateScrollTop() {
      this.scrollTop = window.scrollY || document.documentElement.scrollTop;
    },
    showAddMenu(startHour, startMinute, startTimePart, event) {
      event.preventDefault();
      this.startHour = startHour;
      this.startMinute = startMinute;
      this.startTimePart = startTimePart;
      this.$nextTick(() => {
        $(document).scrollTop(this.scrollTop);
      });
      $("#addMenu").show();
      this.$refs.addMenu.focus();
      let calDivOuterHeight = $(".cal-div").outerHeight();
      let calDivOuterWidth = $(".cal-div").outerWidth();
      if (calDivOuterHeight >= 300) {
        calDivOuterHeight = 0;
      } else {
        calDivOuterHeight = calDivOuterHeight + 20;
        calDivOuterWidth = 0;
      }
      let allAboveElementsHeight =
        60 + 30 + 36.2 + 30 + 20 + 42.41 + 16 + calDivOuterHeight;
      let top = event.y + this.scrollTop - allAboveElementsHeight;

      let sideBarOuterWidth = $(".sidebar").outerWidth();
      let allLeftElementsWidth = sideBarOuterWidth + 30 + calDivOuterWidth;
      let addMenuOuterWidth = $(".menu").outerWidth();
      let timeDivOuterWidth = $(".time-div").outerWidth();
      let contentDivOuterWidth = $(".content-div").outerWidth();
      let left = event.x - allLeftElementsWidth;
      if (
        left >=
        timeDivOuterWidth + contentDivOuterWidth - addMenuOuterWidth
      ) {
        left = left - (addMenuOuterWidth + 5);
      }
      this.top = top + "px";
      this.left = left + "px";
    },
    closeAddMenu() {
      $("#addMenu").hide();
    },
    showEditMenu(payload, event) {
      event.preventDefault();
      if (payload.IsPublicHoliday) return;
      this.selectedEventId = payload.Id;
      this.$emit("selectEvent", payload);
      this.id = payload.Id;
      this.eventName = payload.EventName;
      this.location = payload.Location;
      this.date = this.selectedDate;
      this.startHour = payload.StartHour;
      this.startMinute = payload.StartMinute.toString().padStart(2, "0");
      this.startTimePart = payload.StartTimePart;
      this.endHour = payload.EndHour;
      this.endMinute = payload.EndMinute.toString().padStart(2, "0");
      this.endTimePart = payload.EndTimePart;
      this.notes = payload.Notes;
      this.$nextTick(() => {
        $(document).scrollTop(this.scrollTop);
      });
      $("#editMenu").show();
      this.$refs.editMenu.focus();
      let calDivOuterHeight = $(".cal-div").outerHeight();
      let calDivOuterWidth = $(".cal-div").outerWidth();
      if (calDivOuterHeight >= 300) {
        calDivOuterHeight = 0;
      } else {
        calDivOuterHeight = calDivOuterHeight + 20;
        calDivOuterWidth = 0;
      }
      let allAboveElementsHeight =
        60 + 30 + 36.2 + 30 + 20 + 42.41 + 16 + calDivOuterHeight;
      let top = event.y + this.scrollTop - allAboveElementsHeight;

      let sideBarOuterWidth = $(".sidebar").outerWidth();
      let allLeftElementsWidth = sideBarOuterWidth + 30 + calDivOuterWidth;
      let editMenuOuterWidth = $(".menu").outerWidth();
      let timeDivOuterWidth = $(".time-div").outerWidth();
      let contentDivOuterWidth = $(".content-div").outerWidth();
      let left = event.x - allLeftElementsWidth;
      if (
        left >=
        timeDivOuterWidth + contentDivOuterWidth - editMenuOuterWidth
      ) {
        left = left - editMenuOuterWidth + 10;
      }
      this.top = top + "px";
      this.left = left + "px";
    },
    closeEditMenu() {
      $("#editMenu").hide();
    },
    //main function
    getEventByDay() {
      let param = {
        Token: this.tokenObj.Token,
        InstructorId: this.instructorId,
        Date: this.selectedDate,
        SelectedCountries: this.selectedCountries,
      };
      API.schedule
        .getEventByDay(param)
        .then((response) => {
          if (response.data.success) {
            this.events = response.data.data;
            this.loadCalendar(this.events);
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadCalendar(events) {
      if (!events || !events.length) return;
      //adjust width and left
      let contentDivOuterWidth = $(".content-div").outerWidth();
      let alreadyCheckedIndex = [];
      for (let i = 0; i < events.length; i++) {
        if (alreadyCheckedIndex.includes(i)) continue;
        let minTotalStartTimeMinutes = events[i].TotalStartTimeMinutes;
        let maxTotalEndTimeMinutes = events[i].TotalEndTimeMinutes;
        let overlapEvents = [];
        overlapEvents.push(events[i]);
        alreadyCheckedIndex.push(i);
        for (let j = 0; j < events.length; j++) {
          if (i == j || alreadyCheckedIndex.includes(j)) continue;
          let totalStartTimeMinutes = events[j].TotalStartTimeMinutes;
          let totalEndTimeMinutes = events[j].TotalEndTimeMinutes;
          if (
            totalStartTimeMinutes >= minTotalStartTimeMinutes &&
            totalStartTimeMinutes < maxTotalEndTimeMinutes
          ) {
            overlapEvents.push(events[j]);
            alreadyCheckedIndex.push(j);
            if (totalEndTimeMinutes > maxTotalEndTimeMinutes) {
              maxTotalEndTimeMinutes = totalEndTimeMinutes;
            }
          }
        }

        if (!overlapEvents.length) continue;
        let timeDivOuterWidth = $(".time-div").outerWidth();
        let eachElemWidth = contentDivOuterWidth / overlapEvents.length;
        this.$nextTick(() => {
          for (let x = 0; x < overlapEvents.length; x++) {
            let left = timeDivOuterWidth + x * eachElemWidth;
            $(`#event${overlapEvents[x].Id}`).outerWidth(`${eachElemWidth}px`);
            $(`#event${overlapEvents[x].Id}`).css("left", `${left}px`);
          }
        });
      }
      //adjust height and top
      this.$nextTick(() => {
        for (let item of events) {
          let duration = item.TotalEndTimeMinutes - item.TotalStartTimeMinutes;
          $(`#event${item.Id}`).outerHeight(`${duration}px`);
          $(`#event${item.Id}`).css("top", `${item.TotalStartTimeMinutes}px`);
        }
      });
    },
    save() {
      //validation
      if (
        (this.startHour != "" || this.startMinute != "") &&
        (this.endHour != "" || this.endMinute != "")
      ) {
        let startHour = this.startHour != "" ? parseInt(this.startHour) : 0;
        let startMinute =
          this.startMinute != "" ? parseInt(this.startMinute) : 0;
        let totalStartTimeMinutes =
          (this.startTimePart == "AM"
            ? startHour == 12
              ? 0
              : startHour
            : startHour < 12
            ? startHour + 12
            : 12) *
            60 +
          startMinute;

        let endHour = this.endHour != "" ? parseInt(this.endHour) : 0;
        let endMinute = this.endMinute != "" ? parseInt(this.endMinute) : 0;
        let totalEndTimeMinutes =
          (this.endTimePart == "AM"
            ? endHour == 12
              ? 0
              : endHour
            : endHour < 12
            ? endHour + 12
            : 12) *
            60 +
          endMinute;

        if (totalEndTimeMinutes <= totalStartTimeMinutes) {
          this.$swal("End Time must be later than Start Time", {
            icon: "error",
          });
          return;
        }
      }
      //save
      let param = {
        Token: this.tokenObj.Token,
        Id: this.id,
        EventName: this.eventName,
        Location: this.location,
        CalendarDate: this.date,
        StartHour: this.startHour,
        StartMinute: this.startMinute,
        StartTimePart: this.startTimePart,
        EndHour: this.endHour,
        EndMinute: this.endMinute,
        EndTimePart: this.endTimePart,
        Notes: this.notes,
      };
      API.schedule
        .saveEvent(param)
        .then((response) => {
          if (!response.data.success)
            this.$swal(response.data.message, { icon: "error" });
          if (response.data.success) {
            this.getEventByDay();
            $("#addEvent").modal("hide");
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    remove() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.id,
      };
      API.schedule
        .deleteEvent(param)
        .then((response) => {
          if (!response.data.success)
            this.$swal(response.data.message, { icon: "error" });
          if (response.data.success) {
            this.getEventByDay();
            $("#editMenu").hide();
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },
  created() {
    this.getEventByDay();
  },
  mounted() {
    this.updateScrollTop();
    window.addEventListener("scroll", this.updateScrollTop);
    window.addEventListener("resize", this.updateCalendar);
    //scroll to next available event
    window.setTimeout(() => {
      if (this.events && this.events.length) {
        this.$nextTick(() => {
          $(document).scrollTop($(`#event${this.events[0].Id}`).position().top);
        });
      }
    }, 300);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.updateScrollTop);
    window.removeEventListener("resize", this.updateCalendar);
  },
};
</script>

<style scoped>
.container-div {
  position: relative;
  cursor: pointer;
}
.time-div {
  color: #495057;
  background-color: #e9ecef;
  border-color: lightgray;
  width: 60px;
  vertical-align: top;
  padding-top: 1px;
  padding-right: 3px;
  text-align: right;
  height: 60px;
  border: 1px solid #dee2e6;
}
.content-div {
  height: 60px;
  padding: 0;
  border-bottom: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  width: 100%;
}
.container-div div:nth-child(1) .content-div {
  border-top: 1px solid #dee2e6 !important;
}
.event-div {
  position: absolute;
  color: white;
  padding: 3px 5px 3px 5px;
  line-height: 15px;
  font-size: 12px;
  overflow: auto;
}
.time-span {
  letter-spacing: -0.5px;
}
.menu {
  max-width: fit-content;
  border: 1px solid lightgrey;
  background: #fafafa;
  display: block;
  position: absolute;
  z-index: 99;
  font-size: 11px;
}
.menu-item {
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 1px;
  cursor: pointer;
}
.menu-item:hover {
  background: #d0d0d0;
}
.border-gray {
  border: 1px solid #dee2e6;
}
.selected {
  border: 2px solid black;
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/Other/MyCalendarDay.vue